export const fileItems = [
  {
    id: "file-1",
    icon: "ri-image-2-line",
    type: "ZIP",
    name: "截图合辑_第一批_含时间戳.zip",
    pages: "共 128 张",
    size: "48.2 MB",
    downloads: 1204,
    updatedAt: "09-10",
  },
  {
    id: "file-2",
    icon: "ri-mic-line",
    type: "MP3",
    name: "录音节选_时间轴标注版.mp3",
    pages: "时长 42:16",
    size: "36.8 MB",
    downloads: 968,
    updatedAt: "09-09",
  },
  {
    id: "file-3",
    icon: "ri-file-pdf-2-line",
    type: "PDF",
    name: "材料扫描件_逐页摘要.pdf",
    pages: "共 12 页",
    size: "12.4 MB",
    downloads: 742,
    updatedAt: "09-08",
  },
  {
    id: "file-4",
    icon: "ri-file-excel-2-line",
    type: "XLSX",
    name: "时间线整理表_v7.xlsx",
    pages: "6 个工作表",
    size: "2.1 MB",
    downloads: 516,
    updatedAt: "09-07",
  },
  {
    id: "file-5",
    icon: "ri-file-text-line",
    type: "MD",
    name: "说法差异对照说明.md",
    pages: "7 版记录",
    size: "0.3 MB",
    downloads: 389,
    updatedAt: "09-06",
  },
  {
    id: "file-6",
    icon: "ri-file-chart-2-line",
    type: "CSV",
    name: "证据索引清单_总表.csv",
    pages: "1,286 行",
    size: "0.9 MB",
    downloads: 297,
    updatedAt: "09-05",
  },
];